(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Diwali night band: arm (dim) only when it is still below the fold, then light it once. */
  const initNight = (band) => {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const rect = band.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) return;
    band.classList.add('gr-night--armed');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          band.classList.add('is-lit');
          io.disconnect();
        });
      },
      { rootMargin: '0px 0px -30% 0px', threshold: 0.15 }
    );
    io.observe(band);
  };

  /* Gift note character counter. */
  const initCounters = () => {
    document.querySelectorAll('[data-gr-counter]').forEach((field) => {
      const out = document.getElementById(field.dataset.grCounter);
      if (!out) return;
      const max = field.getAttribute('maxlength');
      const update = () => { out.textContent = `${field.value.length} / ${max}`; };
      field.addEventListener('input', update);
      update();
    });
  };

  /* Mobile sticky add to cart mirrors the main button, its label and the selected price. */
  const initSticky = () => {
    const bar = document.querySelector('[data-gr-sticky]');
    if (!bar) return;
    const main = document.getElementById(bar.dataset.grSticky);
    const btn = bar.querySelector('button');
    if (!main || !btn || !('IntersectionObserver' in window)) return;
    const label = bar.querySelector('.gr-sticky-atc__label');
    const sync = () => {
      btn.disabled = main.disabled;
      const mainLabel = main.querySelector('span');
      if (mainLabel && label) label.textContent = mainLabel.textContent.trim();
      btn.classList.toggle('is-loading', main.classList.contains('loading'));
    };
    btn.addEventListener('click', () => main.click());
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true });
    const footerOnly = window.matchMedia('(max-width: 989px)');
    new IntersectionObserver(([entry]) => {
      const show = footerOnly.matches || !entry.isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
    }).observe(main);
    sync();
  };

  /* Coupons: tap copies the code and applies it to this shopper's checkout. */
  const initOffers = (root = document) => {
    root.querySelectorAll('[data-gr-offer]').forEach((btn) => {
      const label = btn.querySelector('[data-gr-offer-label]');
      const idle = label ? label.textContent : '';
      btn.addEventListener('click', async () => {
        const code = btn.dataset.grOffer;
        try { await navigator.clipboard.writeText(code); } catch (e) { /* clipboard blocked */ }
        let applied = false;
        try { const res = await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`, { credentials: 'same-origin' }); applied = res.ok; } catch (e) { /* offline */ }
        btn.classList.add('is-done');
        if (label) label.textContent = applied ? 'Applied' : 'Copied';
        setTimeout(() => { btn.classList.remove('is-done'); if (label) label.textContent = idle; }, 4000);
      });
    });
  };

  /* India Post circles by pincode prefix (three digits win over two). */
  const PIN3 = { 160: 'Chandigarh', 194: 'Ladakh', 246: 'Uttarakhand', 247: 'Uttarakhand', 248: 'Uttarakhand', 249: 'Uttarakhand', 262: 'Uttarakhand', 263: 'Uttarakhand', 396: 'Dadra & Nagar Haveli and Daman & Diu', 403: 'Goa', 605: 'Puducherry', 737: 'Sikkim', 744: 'Andaman & Nicobar', 790: 'Arunachal Pradesh', 791: 'Arunachal Pradesh', 792: 'Arunachal Pradesh', 793: 'Meghalaya', 794: 'Meghalaya', 795: 'Manipur', 796: 'Mizoram', 797: 'Nagaland', 798: 'Nagaland', 799: 'Tripura', 814: 'Jharkhand', 815: 'Jharkhand', 816: 'Jharkhand', 822: 'Jharkhand', 825: 'Jharkhand', 826: 'Jharkhand', 827: 'Jharkhand', 828: 'Jharkhand', 829: 'Jharkhand', 831: 'Jharkhand', 832: 'Jharkhand', 833: 'Jharkhand', 834: 'Jharkhand', 835: 'Jharkhand' };
  const PIN2 = [[11, 11, 'Delhi'], [12, 13, 'Haryana'], [14, 16, 'Punjab'], [17, 17, 'Himachal Pradesh'], [18, 19, 'Jammu & Kashmir'], [20, 28, 'Uttar Pradesh'], [30, 34, 'Rajasthan'], [36, 39, 'Gujarat'], [40, 44, 'Maharashtra'], [45, 48, 'Madhya Pradesh'], [49, 49, 'Chhattisgarh'], [50, 50, 'Telangana'], [51, 53, 'Andhra Pradesh'], [56, 59, 'Karnataka'], [60, 64, 'Tamil Nadu'], [67, 69, 'Kerala'], [70, 74, 'West Bengal'], [75, 77, 'Odisha'], [78, 78, 'Assam'], [79, 79, 'the North East'], [80, 85, 'Bihar']];
  const pinState = (pin) => {
    const p3 = Number(pin.slice(0, 3));
    if (PIN3[p3]) return PIN3[p3];
    const p2 = Number(pin.slice(0, 2));
    const hit = PIN2.find(([a, b]) => p2 >= a && p2 <= b);
    return hit ? hit[2] : null;
  };

  /* Pincode check: an estimated window from the merchant's dispatch and courier days (Monday to Saturday). */
  const initPincode = (root = document) => {
    root.querySelectorAll('[data-gr-pincode]').forEach((box) => {
      const form = box.querySelector('form');
      const input = box.querySelector('input');
      const out = box.querySelector('.gr-pincode__result');
      if (!form || !input || !out) return;
      const n = (k) => Number(box.dataset[k] || 0);
      const metro = (box.dataset.metro || '').split(',').map((x) => x.trim()).filter(Boolean);
      const addWorkdays = (from, days) => { const d = new Date(from); let left = days; while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) left -= 1; } return d; };
      const fmt = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      const check = (pin) => {
        box.classList.remove('is-error', 'is-ok');
        const state = /^[1-9][0-9]{5}$/.test(pin) ? pinState(pin) : null;
        if (!state) { box.classList.add('is-error'); out.textContent = 'Enter a valid 6-digit Indian pincode.'; return; }
        const isMetro = metro.some((p) => pin.startsWith(p));
        const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        const shipped = addWorkdays(now, n('dispatch'));
        const from = addWorkdays(shipped, isMetro ? n('metroMin') : n('min'));
        const to = addWorkdays(shipped, isMetro ? n('metroMax') : n('max'));
        box.classList.add('is-ok');
        out.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12.4l2.7 2.7L16.2 9.5"/></svg><span>Delivers to <strong>${state}</strong> · estimated <strong>${fmt.format(from)}${to > from ? ` – ${fmt.format(to)}` : ''}</strong></span>`;
        try { window.localStorage.setItem('gr-pincode', pin); } catch (e) { /* storage blocked */ }
      };
      input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        if (input.value.length === 6) check(input.value);
        else { box.classList.remove('is-error', 'is-ok'); out.textContent = ''; }
      });
      form.addEventListener('submit', (e) => { e.preventDefault(); check(input.value.trim()); });
      let saved = null;
      try { saved = window.localStorage.getItem('gr-pincode'); } catch (e) { /* storage blocked */ }
      if (saved) { input.value = saved; check(saved); }
    });
  };

  /* Benefits / specs tabs. */
  const initTabs = (root = document) => {
    root.querySelectorAll('[data-gr-tabs]').forEach((wrap) => {
      const tabs = [...wrap.querySelectorAll('[role="tab"]')];
      const select = (tab) => tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(next); next.focus();
        });
      });
      const current = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
      if (current) select(current);
    });
  };

  /* Videos play muted while on screen; the speaker button turns sound on. */
  const initVideos = (root = document) => {
    const frames = root.querySelectorAll('[data-gr-video]');
    if (!frames.length) return;
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target.querySelector('video');
        if (!v) return;
        if (entry.isIntersecting && !reduceMotion) v.play().catch(() => {});
        else v.pause();
      });
    }, { threshold: 0.6 }) : null;
    frames.forEach((frame) => {
      const v = frame.querySelector('video');
      const btn = frame.querySelector('.gr-video__sound');
      if (!v) return;
      v.muted = true; v.setAttribute('playsinline', '');
      if (io) io.observe(frame);
      if (btn) btn.addEventListener('click', () => {
        v.muted = !v.muted;
        if (!v.muted) v.play().catch(() => {});
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
      });
    });
  };

  /* Hero slides: swipe, dots, arrows and an optional timer that stops for good once the shopper takes over. */
  const initSliders = (root = document) => {
    root.querySelectorAll('[data-gr-slider]').forEach((stage) => {
      if (stage.dataset.grReady) return;
      stage.dataset.grReady = '1';
      const track = stage.querySelector('.gr-hero__track');
      const slides = track ? [...track.children] : [];
      if (slides.length < 2) return;
      const dots = [...stage.querySelectorAll('[data-gr-dot]')];
      const ms = Number(stage.dataset.interval) || 0;
      let index = 0;
      let timer = 0;
      let playing = ms > 0 && !reduceMotion;
      let visible = true;
      const schedule = () => {
        clearTimeout(timer);
        stage.classList.toggle('is-playing', playing && visible);
        if (playing && visible && !document.hidden) timer = setTimeout(() => go(index + 1), ms);
      };
      const restartProgress = () => {
        stage.classList.remove('is-playing');
        void stage.offsetWidth;
        schedule();
      };
      const stop = () => { playing = false; schedule(); };
      const go = (i) => {
        const target = slides[(i + slides.length) % slides.length];
        track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      const mark = () => {
        const w = track.clientWidth || 1;
        const i = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
        if (i === index && stage.dataset.grMarked) return;
        stage.dataset.grMarked = '1';
        index = i;
        dots.forEach((d, k) => { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        slides.forEach((s, k) => {
          const link = s.querySelector('a');
          if (link) link.tabIndex = k === i ? 0 : -1;
        });
        schedule();
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      ['pointerdown', 'wheel', 'keydown'].forEach((type) => track.addEventListener(type, stop, { passive: true }));
      dots.forEach((d, k) => d.addEventListener('click', () => { stop(); go(k); }));
      stage.querySelector('[data-gr-prev]')?.addEventListener('click', () => { stop(); go(index - 1); });
      stage.querySelector('[data-gr-next]')?.addEventListener('click', () => { stop(); go(index + 1); });
      stage.addEventListener('focusin', stop);
      document.addEventListener('visibilitychange', restartProgress);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; restartProgress(); }, { threshold: 0.35 }).observe(stage);
      }
      document.addEventListener('shopify:block:select', (e) => {
        const k = slides.findIndex((s) => s.dataset.blockId && s.dataset.blockId === e.detail?.blockId);
        if (k < 0) return;
        stop();
        go(k);
      });
      mark();
    });
  };

  /* Cart drawer: the Total Price bar opens the MRP breakdown upward. The drawer is re-rendered from the
     server on every cart change, so the open/closed choice is kept here and re-applied after each render. */
  const initCartSummary = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    let open = false;
    const apply = () => {
      drawer.querySelectorAll('[data-gr-sum-toggle]').forEach((t) => {
        t.setAttribute('aria-expanded', String(open));
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !open;
      });
    };
    drawer.addEventListener('click', (e) => {
      const t = e.target.closest('[data-gr-sum-toggle]');
      if (!t) return;
      open = t.getAttribute('aria-expanded') !== 'true';
      apply();
    });
    if ('MutationObserver' in window) {
      new MutationObserver(() => {
        const t = drawer.querySelector('[data-gr-sum-toggle]');
        if (t && t.getAttribute('aria-expanded') !== String(open)) apply();
      }).observe(drawer, { childList: true, subtree: true });
    }
  };

  /* Daily dispatched figure: one number per India-time day from the merchant's range (mirrors the Liquid). */
  const initDaily = (root = document) => {
    root.querySelectorAll('[data-gr-daily]').forEach((el) => {
      const min = Number(el.dataset.min);
      const max = Number(el.dataset.max);
      const step = Math.max(1, Number(el.dataset.step) || 1);
      const steps = Math.max(1, Math.floor((max - min) / step) + 1);
      const day = Math.floor((Math.floor(Date.now() / 1000) + 19800) / 86400);
      const n = ((day * day * 3 + day) % steps) * step + min;
      el.textContent = (el.dataset.text || '[count]').replace('[count]', n);
    });
  };

  /* Product photos on phones: see-through dots instead of the 1/8 counter. */
  const initDots = (root = document) => {
    root.querySelectorAll('.product__media-wrapper slider-component').forEach((sc) => {
      const list = sc.querySelector('.product__media-list');
      if (!list || sc.querySelector('.gr-dots')) return;
      const slides = () => [...list.children].filter((li) => li.classList.contains('product__media-item') && getComputedStyle(li).display !== 'none');
      const count = slides().length;
      if (count < 2) return;
      const dots = document.createElement('div');
      dots.className = 'gr-dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Product photos');
      for (let i = 0; i < count; i += 1) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gr-dots__dot';
        b.setAttribute('aria-label', `Show photo ${i + 1} of ${count}`);
        b.addEventListener('click', () => {
          const s = slides();
          if (s[i]) list.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        dots.append(b);
      }
      sc.append(dots);
      const update = () => {
        const s = slides();
        const w = s[0] ? s[0].getBoundingClientRect().width : 1;
        const idx = Math.min(count - 1, Math.max(0, Math.round(list.scrollLeft / w)));
        dots.querySelectorAll('.gr-dots__dot').forEach((d, i) => { if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      };
      let raf = 0;
      list.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      update();
    });
  };

  /* Long descriptions open with View more. */
  const initMore = (root = document) => {
    root.querySelectorAll('[data-gr-more]').forEach((wrap) => {
      const body = wrap.querySelector('.gr-more__body');
      const toggle = wrap.querySelector('.gr-more__toggle');
      if (!body || !toggle) return;
      if (body.scrollHeight <= body.clientHeight + 4) { wrap.classList.add('is-open'); return; }
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const open = wrap.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('[data-more]').hidden = open;
        toggle.querySelector('[data-less]').hidden = !open;
        if (!open) wrap.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  };

  /* Days to the occasion, counted in India time so a cached page never shows yesterday's number. */
  const initCountdowns = (root = document) => {
    root.querySelectorAll('[data-gr-countdown]').forEach((el) => {
      const target = Date.parse(`${el.dataset.grCountdown}T00:00:00+05:30`);
      if (Number.isNaN(target)) return;
      const days = Math.ceil((target - Date.now()) / 864e5);
      if (days < 0) { el.closest('.gr-hero__when, .gr-urgency__when')?.setAttribute('hidden', ''); return; }
      if (days > 1) el.textContent = (el.dataset.many || '').replace('[days]', days);
      else if (days === 1) el.textContent = el.dataset.one || '';
      else el.textContent = el.dataset.today || '';
    });
  };

  /* Gift-list slide-up: once per session, snoozed after closing, never on cart. */
  const initSlideup = () => {
    const panel = document.querySelector('[data-gr-slideup]');
    if (!panel) return;
    const store = {
      get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
      set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
      sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
      sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
    };
    const open = () => { panel.hidden = false; requestAnimationFrame(() => panel.classList.add('is-open')); store.sset('gr-slideup-seen', '1'); };
    const close = () => {
      panel.classList.remove('is-open');
      const days = Number(panel.dataset.snoozeDays || 14);
      store.set('gr-slideup-snooze', String(Date.now() + days * 864e5));
      setTimeout(() => { panel.hidden = true; }, 600);
    };
    panel.querySelectorAll('[data-gr-slideup-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
    if (panel.querySelector('[data-gr-slideup-done]')) { open(); return; }
    const snoozed = Number(store.get('gr-slideup-snooze') || 0) > Date.now();
    if (snoozed || store.sget('gr-slideup-seen')) return;
    setTimeout(open, Number(panel.dataset.delay || 50) * 1000);
  };

  const init = () => {
    document.querySelectorAll('[data-gr-night]').forEach(initNight);
    initCounters();
    initSticky();
    initCountdowns();
    initMore();
    initDaily();
    initDots();
    initOffers();
    initPincode();
    initTabs();
    initVideos();
    initSliders();
    initCartSummary();
    initSlideup();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    initCountdowns(e.target);
    initMore(e.target);
    initDaily(e.target);
    initDots(e.target);
    initOffers(e.target);
    initPincode(e.target);
    initTabs(e.target);
    initVideos(e.target);
    initSliders(e.target);
    e.target.querySelectorAll('[data-gr-night]').forEach((band) => band.classList.remove('gr-night--armed'));
  });
})();
